import { render, staticRenderFns } from "./InsightList.vue?vue&type=template&id=706196a4"
import script from "./InsightList.vue?vue&type=script&lang=js"
export * from "./InsightList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706196a4')) {
      api.createRecord('706196a4', component.options)
    } else {
      api.reload('706196a4', component.options)
    }
    module.hot.accept("./InsightList.vue?vue&type=template&id=706196a4", function () {
      api.rerender('706196a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Insight/InsightList.vue"
export default component.exports